/**
 * Implements a KendoUI NumericTextBox range as a Marionette Behavior.
 */

import "kendo.core";
import "kendo.dataviz";

import Marionette from "backbone.marionette";
import defaultsDeep from "lodash.defaultsdeep";
import culture from "../../config/kendo-ui/culture";

// apply culture overrides
kendo.cultures.current = defaultsDeep(culture, kendo.cultures.current);

class NumericRange extends Marionette.Behavior {
  defaults() {
    return {
      selector: ".numeric-range",
    };
  }

  events() {
    return {
      "shown.bs.dropdown": "_onDropdownShown",
    };
  }

  initialize() {
    this.rendered = false;
  }

  _onDropdownShown() {
    if (!this.rendered) {
      this.$(this.options.selector).each(function () {
        const $el = $(this);
        const options = $el.data();

        // instantiate input
        $el.kendoNumericTextBox(options);
      });

      this.rendered = true;
    }
  }
}

export { NumericRange as default };
